import { getKefConfig } from '@/views/Message/webApi'

// 是否微信小程序内打开
export function isWechatMP()
{
  return (
    navigator.userAgent.match(/miniprogram/) ||
    window.__wxjs_environment === 'miniprogram'
  )
}
// 增加客服
export function addQIYU(config)
{

  if (isWechatMP())
  {
    return
  }

  getKefConfig()
    .then(({ data }) =>
    {
      ; (function (w, d, n, a, j, address)
      {

        w[n] =
          w[n] ||
          function ()
          {
            ; (w[n].a = w[n].a || []).push(arguments)
          }
        j = d.createElement('script')
        j.async = true

        // console.log(data.address)
        j.src = address
        d.body.appendChild(j)
        ysf('config', config)
      })(window, document, 'ysf', undefined, undefined, data.address)
    })
    .catch((err) =>
    {
      console.log(err)
    })
}
// 删除客服
export function delQIYU()
{
  window.hasOwnProperty('ysf') && ysf('logoff')
}
